import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import image from "../img/email-confirmation.png";
import { useNavigate } from "react-router";
import AuthContext from "../context/AuthContext";

function EmailConfirmation() {

  const navigate = useNavigate(AuthContext);
  const handleClickStart = () => {
    navigate("/login");
  }

  const handleGmailWeb = () => {
        const recipient = "adresse@email.com";
        const subject = encodeURIComponent("Objet du mail");
        const body = encodeURIComponent("Contenu du message ici...");
        const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${recipient}&su=${subject}&body=${body}`;

        window.open(gmailUrl, "_blank");
    };

  return <div className="container kl-verification-mail">
      <div className="kl-admin-header">
        <button onClick={() => window.history.back()} className="p-0 kl-back-button">
          <FontAwesomeIcon icon={faArrowLeft} className="kl-icon-arrow" />
        </button>
      </div>
      <div className="kl-email-content">
        <div className="kl-email-info">
          <h1>Nous vous avons envoye un mail de confirmation.</h1>
          <p>Vous pouvez des maintenant commencer a ajouter vos documents</p>
        </div>
        <div className="kl-confirmation-image">
          <img src={image} alt="image confirmation" />
        </div>
        <div className="kl-button-email-confirmation">
          <Button variant="light" size="lg" className="kl-open-email-box" onClick={handleGmailWeb}>
            {"Ouvrir ma boite mail"}
          </Button>
          <Button variant="primary" size="lg" className="kl-start-contab" onClick={handleClickStart}>
            {"Commencer sur Comptaride"}
          </Button>
        </div>
      </div>
    </div>;
}

export default EmailConfirmation;
